<template>
  <div v-loading="fetchInProgress" class="program-list-table">
    <el-table
      :data="events"
      empty-text="There are no events yet"
      :default-sort="{ prop: 'created_at', order: 'descending' }"
    >
      <el-table-column label="Name" prop="name" sortable>
        <template slot-scope="{ row }">
          {{ row.name }}
        </template>
      </el-table-column>
      <el-table-column label="Created at" prop="created_at" sortable>
        <template slot-scope="{ row }">
          {{ row.created_at | date }}
        </template>
      </el-table-column>
      <el-table-column label="Companies">
        <template slot-scope="{ row }">
          {{ row.startups_count }}
        </template>
      </el-table-column>
      <el-table-column label="Attendees">
        <template slot-scope="{ row }">
          {{ row.users_count }}
        </template>
      </el-table-column>
      <el-table-column label="Actions">
        <template slot-scope="{ row }">
          <router-link
            :to="{
              name: 'eventDetails',
              params: { eventId: row.id },
            }"
          >
            Preview
          </router-link>
          <el-divider v-if="canEdit({ event: row })" direction="vertical" />
          <router-link
            v-if="canEdit({ event: row })"
            :to="getEditRoute({ event: row })"
          >
            Edit
          </router-link>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    events: { type: Array, default: () => [] },
    fetchInProgress: { type: Boolean, default: false },
  },
  computed: {
    ...mapState({
      user: (s) => s.user.data,
    }),
  },
  methods: {
    canEdit({ event }) {
      return (
        this.user.isAdmin || event.organization.id === this.user.organizationId
      )
    },

    getEditRoute({ event }) {
      const params = {
        organizationId: event.organization.id,
        eventId: event.id,
      }
      if (this.user.isAdmin) {
        return { name: 'adminOrganizationEventEdit', params }
      } else {
        return { name: 'eventEdit', params }
      }
    },
  },
}
</script>
